import { useMedia } from 'react-use';
import { useTheme } from 'styled-components';

export const useBreakpoints = () => {
    const theme = useTheme();
    const notMobile = useMedia(`(min-width: ${theme.breakpoints.mobile})`);
    const notSmallTablet = useMedia(`(min-width: ${theme.breakpoints.tabletSmall})`);
    const notTablet = useMedia(`(min-width: ${theme.breakpoints.tablet})`);
    const notSmallDesktop = useMedia(`(min-width: ${theme.breakpoints.desktopSmall})`);
    const notDesktop = useMedia(`(min-width: ${theme.breakpoints.desktop})`);

    return {
        isMobile: !notMobile,
        isSmallTablet: !notSmallTablet,
        isTablet: !notTablet,
        isSmallDesktop: !notSmallDesktop,
        isDesktop: !notDesktop,
    };
};
